import { Route, Routes } from 'react-router-dom';
import SubLocationsList from './sub-locations-list';

const SubLocationsRouting = () => {
  return (
    <Routes>
      <Route path='' element={<SubLocationsList />} />
    </Routes>
  );
};

export default SubLocationsRouting;
